import { render, staticRenderFns } from "./ApplicationWaiting.vue?vue&type=template&id=dfb4c24e&scoped=true&"
import script from "./ApplicationWaiting.vue?vue&type=script&lang=js&"
export * from "./ApplicationWaiting.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationWaiting.vue?vue&type=style&index=0&id=dfb4c24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb4c24e",
  null
  
)

export default component.exports